import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import AddIcon from '@mui/icons-material/Add';
import EventSlider from "./EventSlider";

export default function Hero() {
  const [eventCode, setEventCode] = useState("");
  const [setEventDetails] = useState(null);
  const [setEventDocId] = useState(null);
  const [error, setError] = useState('');
  
  const navigate = useNavigate();
  
  useEffect(() => {
    if (eventCode) {
      fetchEvent(eventCode);
    }
  },[eventCode]);
  
        
          const fetchEvent = async (code) => {
          try {
            setError('');
            setEventDetails(null);
            setEventDocId(null);
      
            // Find the event document by eventCode
            const eventsRef = collection(db, 'events');
            const eventQuery = query(eventsRef, where('eventCode', '==', code));
            const eventSnapshot = await getDocs(eventQuery);
      
            if (!eventSnapshot.empty) {
              // Assume the first matching event document
              const eventDoc = eventSnapshot.docs[0];
              const eventData = eventDoc.data();
      
              setEventDocId(eventDoc.id);  // Store document ID for post retrieval
              setEventDetails({
                eventImage: eventData.eventImageURL,
                eventName: eventData.eventName,
                eventCode: eventData.eventCode,
                eventOwnerName: eventData.eventOwnerName,
              });
            } else {
              setError('No event found with that event code.');
            }
          } catch (err) {
            console.error("Error fetching event:", err);
            setError('Failed to retrieve event data.');
          }
        };

  // const btm = {    bottom: '0',    position: 'absolute'};
      
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        // height: '70vh',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}      
    >
      <Container
        sx={{
          height: '1005',
          width: '100%',
          display: 'flex',
          margin: 'auto',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 14, sm: 12 },
          pb: { xs: 8, sm: 2 },
        }}
        >        
        <EventSlider 
        // style={btm}
        />                  
      </Container>
    </Box>
  );
}
